



























import SuperadminOptionsForm from '@core/components/forms/superadmin-options-form.vue';
import ImportTenantData from '@core/components/forms/import-tenant-data.vue';
import StripeConnectOptions from '@core/components/forms/stripe-connect-options-form.vue';
import PageTitle from '@shared/layouts/components/page-title/page-title.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import SuperAdminNewTenantForm from '@core/components/forms/super-admin-new-tenant-form.vue';

@Component({
  name: 'bpc-superadmin-options',
  components: {
    'bpc-page-title': PageTitle,
    'bpc-superadmin-options-form': SuperadminOptionsForm,
    'bpc-import-tenant-data': ImportTenantData,
    'bpc-stripe-connect-options': StripeConnectOptions,
    'bpc-super-admin-new-tenant-form': SuperAdminNewTenantForm,
  },
})
export default class SuperadminOptionsPage extends Vue {
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
  refreshPage() {
    this.$router.go(null);
  }
}
